"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoredEvidence = exports.FieldUpdatedBy = exports.FieldCreatedBy = exports.AuthoredFields = exports.useAuthoredColumns = void 0;
const react_1 = require("react");
const detail_actionbar_empty_1 = require("../../detail/detail-actionbar-empty");
const authored_columns_1 = require("./authored-columns");
Object.defineProperty(exports, "useAuthoredColumns", { enumerable: true, get: function () { return authored_columns_1.useAuthoredColumns; } });
const authored_fields_1 = require("./authored-fields");
Object.defineProperty(exports, "AuthoredFields", { enumerable: true, get: function () { return authored_fields_1.AuthoredFields; } });
Object.defineProperty(exports, "FieldCreatedBy", { enumerable: true, get: function () { return authored_fields_1.FieldCreatedBy; } });
Object.defineProperty(exports, "FieldUpdatedBy", { enumerable: true, get: function () { return authored_fields_1.FieldUpdatedBy; } });
function useAuthoredEvidence(options) {
    var _a, _b, _c, _d, _e;
    const { authoredColumns } = authored_columns_1.useAuthoredColumns();
    const columns = (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns) !== null && _b !== void 0 ? _b : authoredColumns;
    const GeneralFieldsComponent = (_d = (_c = options.detailProps) === null || _c === void 0 ? void 0 : _c.GeneralFieldsComponent) !== null && _d !== void 0 ? _d : authored_fields_1.AuthoredFields;
    const toolbarProps = react_1.useMemo(() => {
        var _a;
        return ({
            ActionBar: detail_actionbar_empty_1.DetailEmptyActionbar,
            ...(_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.toolbarProps,
        });
    }, [(_e = options.detailProps) === null || _e === void 0 ? void 0 : _e.toolbarProps]);
    return {
        ...options,
        tableProps: { ...options.tableProps, columns },
        detailProps: {
            ...options.detailProps,
            GeneralFieldsComponent,
            toolbarProps,
        },
    };
}
exports.useAuthoredEvidence = useAuthoredEvidence;
//# sourceMappingURL=authored-evidence.js.map